import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-total-result',
    templateUrl: './a-total-result.component.html',
    styleUrls: ['./a-total-result.component.scss'],
    standalone: false
})
export class ATotalResultComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
